import type {Active, DropSide as DropSideType, Over} from '@github-ui/drag-and-drop'
import {DropSide} from '@github-ui/drag-and-drop'

export const getVerticalDropSide = (active: Active | null, over: Over | null): DropSideType | null => {
  const activeTop = active?.rect?.current?.translated?.top
  const overTop = over?.rect.top

  if (typeof activeTop !== 'number' || typeof overTop !== 'number') {
    return null
  }

  return activeTop <= overTop ? DropSide.BEFORE : DropSide.AFTER
}
